const SALES_UI_SCHEMA = {
  table: {
    columnSections: [
      {
        key: 'projected',
        title: 'Projected',
      },
      {
        key: 'actual',
        title: 'Actual',
      },
      {
        key: 'difference',
        title: 'Differences',
      },
    ],
    items: [
      {
        property: 'projectedSalesValue',
        columnDescription: 'Projected sales',
        columnHeader: 'projected sales',
        formula: 'data.projectedSales ? NUMBER(data.projectedSales.amount) : 0',
        calculateOnAggregated: false,
        sumUp: true,
        unit: 'currency',
        emptyValue: '"0"',
        includeForTotals: true,
        activeByDefault: true,
        sectionKey: 'projected',
      },
      {
        property: 'actualSalesValue',
        columnDescription: 'Actual sales',
        columnHeader: 'actual sales',
        formula: 'data.actualSales ? NUMBER(data.actualSales.amount) : 0',
        calculateOnAggregated: false,
        sumUp: true,
        unit: 'currency',
        emptyValue: '"0"',
        includeForTotals: true,
        activeByDefault: true,
        sectionKey: 'actual',
      },
      {
        property: 'difference',
        columnDescription: 'Difference sales',
        columnHeader: 'diff. sales',
        formula:
          '(data.actualSales ? NUMBER(data.actualSales.amount) : 0) - (data.projectedSales ? NUMBER(data.projectedSales.amount) : 0)',
        calculateOnAggregated: false,
        sumUp: true,
        unit: 'currency',
        emptyValue: '"0"',
        includeForTotals: true,
        activeByDefault: true,
        delta: true,
        sectionKey: 'difference',
      },
      {
        property: 'labor',
        columnDescription: 'Projected labor %',
        columnHeader: 'projected labor %',
        formula:
          'data.projectedSalesValue > 0 ? ROUND_DECIMAL(data.estimatedWages * 100 / data.projectedSalesValue, 2) : 0',
        calculateOnAggregated: true,
        if: 'orgSettings.laborPercentEnabled',
        unit: '%',
        disabledDescription:
          'Labor percentage needs to be enabled for this column. Enable it in settings.',
        emptyValue: '"0"',
        includeForTotals: true,
        activeByDefault: true,
        sectionKey: 'projected',
      },
      {
        property: 'actualLabor',
        columnDescription: 'Actual labor %',
        columnHeader: 'actual labor %',
        formula:
          'data.actualSalesValue > 0 ? ROUND_DECIMAL(data.actualWages * 100 / data.actualSalesValue, 2) : 0',
        calculateOnAggregated: true,
        if: 'orgSettings.laborPercentEnabled',
        unit: '%',
        disabledDescription:
          'Labor percentage needs to be enabled for this column. Enable it in settings.',
        emptyValue: '"0"',
        includeForTotals: true,
        activeByDefault: true,
        sectionKey: 'actual',
      },
      {
        property: 'differenceLabor',
        columnDescription: 'Difference labor %',
        columnHeader: 'diff. labor %',
        formula: 'ROUND_DECIMAL(data.actualLabor - data.labor, 2)',
        calculateOnAggregated: true,
        if: 'orgSettings.laborPercentEnabled',
        unit: '%',
        disabledDescription:
          'Labor percentage needs to be enabled for this column. Enable it in settings.',
        emptyValue: '"0"',
        includeForTotals: true,
        activeByDefault: true,
        delta: true,
        sectionKey: 'difference',
      },
    ],
  },
};

export default SALES_UI_SCHEMA;
